import React, {useRef, useState} from "react";
import {useReactToPrint} from "react-to-print";
import {useSelector} from "react-redux";
import ReactDOM from "react-dom";
import {useMediaQuery} from "@react-hook/media-query";

import BankCard from "./summary/BankCard";
import {
  addOfficeIdParamToLink,
  CALCULATOR_TYPES,
  getCalculatorType,
  mainMediaMobile,
  removeDotsComas,
  setBodyDataForPdf
} from "../services/helpers";
import {assetsBaseUrl, getShortUrl} from "../services/calculationsApi";
import {stepTitles} from "./steps/stepParts/StepHeader";
import {setField, getSummaryPdfAction} from "../store/actions/calculatorActions";
import {stepStates} from "../services/helpers";
import OverviewModal from "./modals/OverviewModal";
import SharePdfModal from "./modals/SharePdfModal";
import {getStateAsShareableLink} from "../services/stateHelper";
import {getWhatsAppShareText} from "../services/shareHelper";
import {SHARE_PDF} from "../store/actionTypes/calculatorActionTypes";
import ToolInfoComponent from "./summary/ToolInfoComp";
import {FormattedMessage, useIntl} from "react-intl";

function Summary({dispatch, changeStepState}) {
  const intl = useIntl();
  const toolData = useSelector((state) => state.calculator);
  const mediaMatches = useMediaQuery(mainMediaMobile);
  const [mobileSummaryOpened, setMobileSummaryOpened] = useState(false);
  const [isOverviewOpened, setIsOverviewOpened] = useState(false);
  const [isSharePdfOpened, setIsSharePdfOpened] = useState(false);
  const [showPdfSpinner, setShowPdfSpinner] = useState(false);

  const fetchPdf = () => {
    dispatch(
    getSummaryPdfAction(setBodyDataForPdf(toolData), intl.locale)
    ).then(() => setShowPdfSpinner(false))
  }

  const {
    stepState,
    lastActiveStepIndex,
    summaryWithBanksOpened,
    bankData,
    response: {
      totalNeededToBuyHouse
    },
  } = toolData;

  const showNotCompleted = (getCalculatorType() !== CALCULATOR_TYPES.hoeveelKanIkLenen) ? stepState[0] === "filled" && stepState[1] === "filled" && stepState[2] !== "filled" : stepState[0] === "filled" && stepState[1] !== "filled";


  const toggleMobileSummary = (value) => {
    setMobileSummaryOpened(
    typeof value === "boolean" ? value : !mobileSummaryOpened
    );
  };

  const closeSummary = () => {
    toggleMobileSummary(false);

    dispatch(setField("summaryWithBanksOpened", false));

    changeStepState(lastActiveStepIndex, stepStates.active);
  };


  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const openedCondition = mediaMatches && mobileSummaryOpened;

  const toggleOverview = () => {
    setIsOverviewOpened(!isOverviewOpened);
  };

  const toggleSharePdf = () => {
    setIsSharePdfOpened(!isSharePdfOpened);
    dispatch({
      type: SHARE_PDF,
      response: {
        state: 'not_mailed',
        success: null,
        message: false
      }
    })
  };

  const print = () => {
    toggleOverview();

    setTimeout(() => {
      handlePrint();
    }, 200);
  };

  const shareWhatsApp = async () => {
    const url = getStateAsShareableLink(removeDotsComas(toolData));
    const {hostname} = window.location;

    if (hostname.indexOf('localhost') === -1) {
      const shortUrl = await getShortUrl(url, '&utm_source=berekening&utm_medium=whatsapp');
      const shareText = getWhatsAppShareText(toolData, shortUrl.link, intl)
      window.open(`https://api.whatsapp.com/send?text=${shareText}`)
    } else {
      console.log(url);
      console.log(getWhatsAppShareText(toolData, window.location, intl))
    }

  };

  return (
  <div
  className={`ct-step__summary
                ${
  toolData.bankData && !mediaMatches
  ? "ct-step__summary-no-sticky"
  : undefined
  }
                ${
  getCalculatorType() ===
  CALCULATOR_TYPES.kanIkDitHuisBetalen &&
  totalNeededToBuyHouse > 0
  ? "ct-step__summary--kanIkDitHuisBetalen"
  : ""
  }
                ${openedCondition ? "ct-step__summary-opened" : undefined}
                ${
  summaryWithBanksOpened
  ? "ct-step__summary-opened-banks"
  : undefined
  }`}
  id="summary"
  >
    <ToolInfoComponent
    toolData={toolData}
    mediaMatches={mediaMatches}
    toggleMobileSummary={toggleMobileSummary}
    mobileSummaryOpened={mobileSummaryOpened}
    dispatch={dispatch}
    summaryWithBanksOpened={summaryWithBanksOpened}
    changeStepState={changeStepState}
    showNotCompleted={showNotCompleted}
    ></ToolInfoComponent>

    { /* <div className="ct-step__summary-title">
      {toolInfo.title}</div>
    {showNotCompleted && (
    <div className="ct-step__summary-text">
      {" "}
      Dit resultaat is gebaseerd op je leeftijd en inkomen. Maak
      de berekening af voor een compleet overzicht van hoeveel je
      kunt lenen.
    </div>
    )}

    {getCalculatorType() === CALCULATOR_TYPES.kanIkDitHuisBetalen &&
    totalNeededToBuyHouse > 0 ? (
    <div className="ct-step__summary-answer">
      Het lijkt erop dat je het huis{" "}
      {isHouseAffordable ? "" : "niet"} kunt betalen
    </div>
    ) : null}

    <div className="ct-step__summary-results">
      {toolInfo.fields}
    </div> */ }

    {summaryWithBanksOpened &&
    <div className="ct-step__summary-buttons">
      <div className="ct-step__summary-print-and-pdf-buttons">
        <button
        className="ct__button ct__button__summary ct__button-icon"
        disabled={!summaryWithBanksOpened}
        onClick={print}
        >
          <img
          src={`${assetsBaseUrl}/assets/svg/${
          !summaryWithBanksOpened ? "grey/" : ""
          }print.svg`}
          alt=""
          />
        </button>
        {showPdfSpinner}
        <button
        className="ct__button ct__button__summary ct__button-icon"
        disabled={!summaryWithBanksOpened}
        onClick={() => {
          setShowPdfSpinner(true);
          fetchPdf();
        }}
        >
          {showPdfSpinner ? (
          <img className={"ct__button__summary--loading"} src={`${assetsBaseUrl}/assets/svg/loader-dots.svg`} alt=""/>
          ) : (
          <img
          src={`${assetsBaseUrl}/assets/svg/${
          !summaryWithBanksOpened ? "grey/" : ""
          }pdf.svg`}
          alt="pdf icon"
          />
          )}
        </button>
        <button
        className="ct__button ct__button__summary ct__button-icon"
        disabled={!summaryWithBanksOpened}
        onClick={shareWhatsApp}
        >
          <img
          src={`${assetsBaseUrl}/assets/svg/${
          !summaryWithBanksOpened ? "grey/" : ""
          }whatsapp.svg`}
          alt=""
          />
        </button>

        <button
        className="ct__button ct__button__summary ct__button-icon"
        disabled={!summaryWithBanksOpened}
        onClick={toggleSharePdf}
        >
          <img
          src={`${assetsBaseUrl}/assets/svg/${
          !summaryWithBanksOpened ? "grey/" : ""
          }mail.svg`}
          alt=""
          />
        </button>
      </div>
      <div className="ct-step__summary-actions">

        {getCalculatorType() === CALCULATOR_TYPES.hoeveelKanIkLenen &&
        <a href={addOfficeIdParamToLink(`https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur/`)}
           className={`ct__button ct__button--small ct__button--full-width ct-step__summary-actions__advisor ${toolData.bankData ? "ct-header__afspraak" : "ct-step__summary__afspraak"}`}>
          <FormattedMessage id="summary.findAdvisor" defaultMessage="Zoek een adviseur"/>
        </a>
        }

        <button
        className="ct__button ct__button--full-width ct__button__summary ct__button__summary--no-margin ct__button__summary--calculation"
        disabled={!summaryWithBanksOpened || !bankData}
        onClick={toggleOverview}
        >
          <FormattedMessage id={"summary.showCalculation"} defaultMessage={"Toon volledige berekening"}/>
        </button>
      </div>
    </div>
    }

    <div className="ct-step__summary_bank-results">
      {toolData.bankData ? (
      <>
        <div className="ct-step__summary-title ct-step__summary-title--deal">
          <FormattedMessage id={"summary.bestDeal"} defaultMessage={"Dit is jouw beste deal"}/>
        </div>

        <div className="ct-step__summary-text">
          <FormattedMessage id={"summary.bestDealText"} defaultMessage={"Jouw beste deal is berekend aan de hand van de gegevens die je hebt ingevoerd. Dit kun je zien als indicatie, alleen gebaseerd op de geboden laagste rente op dit moment. Een hypotheekadviseur van De Hypotheker kijkt meer uitgebreid naar jouw situatie. Hij of zij vergelijkt vervolgens alle aanbieders (ook je eigen bank), zodat je zeker weet dat je de beste deal krijgt."}/>
        </div>

        <div className="ct-step__summary-banks-list">
          <BankCard
          isMain
          bankData={
          toolData.bankData &&
          toolData.bankData.mainBank
          }
          grossMonthlyCost={
            //(getCalculatorType() === CALCULATOR_TYPES.watWordenMijnMaandLasten) ? toolData.response.grossMonthlyCostHouse : toolData.response.grossMonthlyCost
            toolData.Woning > 0
            ? toolData.response
            .grossMonthlyCostHouse
            : toolData.response.grossMonthlyCost
          }
          />
        </div>
      </>
      ) : null}

      <div className="ct-step__summary-divider"/>

      <div>
        <div className="ct-step__summary-subtitle">
          <FormattedMessage id={"summary.advisorAppointment"} defaultMessage={"Afspraak met een adviseur"}/>
        </div>

                    <div className="ct-step__summary-text">
                      <FormattedMessage id={"summary.advisorAppointmentText"} defaultMessage={"Jouw maximale leenbedrag is mogelijk hoger dan dit resultaat. Het leenbedrag in onze berekening is gebaseerd op de laagste rente op dit moment. Een hogere rente kan in sommige gevallen een hoger leenbedrag opleveren. Maak een vrijblijvende afspraak bij een vestiging bij je in buurt voor inzicht in jouw financiële mogelijkheden"}/>
                    </div>

                    <a
                        href={addOfficeIdParamToLink(`https://www.hypotheker.nl/afspraak-maken-hypotheekadviseur/`)}
                        className={`margin-top__xs-sm ct__button ${
                            toolData.bankData
                                ? "ct-header__afspraak"
                                : "ct-step__summary__afspraak"
                        }`}
                    >
                      <FormattedMessage id={"summary.makeAppointment"} defaultMessage={"Afspraak maken"}/>
                    </a>

      </div>
    </div>

    {mediaMatches && summaryWithBanksOpened ? (
    <div className="ct-step__summary-mobile-header">
      <button
      className="ct_back-button-mobile ct_back-button-summary"
      onClick={closeSummary}
      >
        <img
        src={`${assetsBaseUrl}/assets/svg/arrow-down-secondary.svg`}
        alt=""
        />
        {stepTitles[lastActiveStepIndex]}
      </button>
    </div>
    ) : null}

    {isOverviewOpened
    ? ReactDOM.createPortal(
    <OverviewModal
    toggleOverview={toggleOverview}
    componentRef={componentRef}
    />,
    document.getElementById("overview-modal-portal")
    )
    : null}
    {isSharePdfOpened
    ? ReactDOM.createPortal(
    <SharePdfModal
    toggleOverview={toggleSharePdf}
    toolData={toolData}
    componentRef={componentRef}
    />,
    document.getElementById("overview-modal-portal")
    )
    : null}

  </div>
  );
}

export default Summary;
